import './LoadingScreen.css';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../_Components/Footer';
import Lottie from 'lottie-react';
import hourglass from '../../assets/images/animations/hourglass.json';

function LoadingScreen({ 
  message = "Caricamento in corso...",
  autoNavigate = false,
  navigateTo = '/play',
  delay = 3000,
  showFooter = true 
}) {
  const navigate = useNavigate();

  useEffect(() => {
    if (autoNavigate) {
      const timer = setTimeout(() => {
        navigate(navigateTo);
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [navigate, autoNavigate, navigateTo, delay]);
  
  return (
    <div className="loading-screen">
      <div id='container'>
        <div className="main-content loading-content">
        <Lottie
          animationData={hourglass}
          autoPlay={true}
          loop={true}
          id="loader_animation"
          className="loading-animation"
        />
        <p className="loading-text">
          {message}
        </p>
        </div>
        {showFooter && <Footer />}
      </div>
    </div>
  );
}

export default LoadingScreen;
